import { useIntl } from 'react-intl'

import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

function FlightDealAgentHubDisclaimer() {
  const intl = useIntl()

  const disclaimerMessage = intl.formatMessage({
    id: 'H2beGtyU1rJoax-GcQ4j',
    defaultMessage: 'Luxury Escapes Charter flights to the Maldives only depart Melbourne on Mondays and Male on Sundays',
    description: 'Disclaimer text for Maldives charter flights schedule in agent hub',
  })

  return (
    <BodyTextBlock
      startIcon={<LineInfoCircleIcon />}
      variant="small"
      colour="neutral-two"
    >
      {disclaimerMessage}
    </BodyTextBlock>
  )
}

export default FlightDealAgentHubDisclaimer
